export function isUserManagementEnabled(): boolean {
  return process.env.VUE_APP_FEATURE_FLAG_USER_MANAGMENT === 'true'
}
